import { Stringifiable } from "d3";

export class ApiResponse{
    Status: boolean;
    SuccessMessage: string;
    ErrorMessage: string;
    RedirectURL:string;
    JsonRequest:string;
}
export class resetPassword{
    otp:string;
    mobileNumber:string;
    NewPassword:string;
    ConfirmNewPassword:string;
}


// WEBPACK FOOTER //
// ./src/app/models/OTPResult.ts